module.exports = __webpack_public_path__ + "31055a7cb7b740fa0b55387be7b268a1.webp";